import * as React from "react";
import { useInjector, Link } from "@bb-vendure/admin-ui/react";
const Text = (props: {
  text: string;
  fnc?: () => void;
  ghost?: boolean;
  prefix?: React.JSX.Element;
  surfix?: React.JSX.Element;
}) => {
  return (
    <div
      onClick={() => {
        if (props.fnc) {
          props.fnc();
        }
      }}
      className={`text ${props.ghost ? "button-ghost" : ""}`}
      style={{
        color: "black",
        display: "flex",
        alignItems: "center",
        fontSize: 15,
        fontFamily: "Inter",
        fontWeight: "400",
        wordWrap: "break-word",
      }}
    >
      {props.prefix} {props.text} {props.surfix}
    </div>
  );
};

export default Text;
